import $ from 'jquery';
import { CodeMirrorEditor } from './code-mirror-editor';
const ELEMENT_SELECTOR = '.ui.accordion';
export class Accordion {
    static init($root = $('body')) {
        const $accordionElement = $root.find(ELEMENT_SELECTOR);
        if (!$accordionElement.length) {
            return;
        }
        $('.js__add-action').on('click', e => {
            setTimeout(() => {
                this.initAccordion($(e.currentTarget).parent());
            });
        });
        this.initAccordion($root);
    }
    static initAccordion($root) {
        const $accordionElement = $root.find(ELEMENT_SELECTOR);
        $accordionElement.each((index, element) => {
            const $element = $(element);
            const containCodeMirror = !!$element.find('.js__code-mirror-editor-source:not(.js__load-on-toggle)').length;
            $(element).accordion({
                animateChildren: false,
                onOpen() {
                    const isCodeMirrorLoaded = $element.find('.js__code-mirror-accordion-content.loaded.active').length;
                    const $activeAccordion = $element.find('.js__code-mirror-accordion-content.active');
                    const $codeMirrorToggler = $activeAccordion.find('.js__code-mirror-toggler');
                    if (containCodeMirror && !isCodeMirrorLoaded) {
                        CodeMirrorEditor.init($element);
                        $activeAccordion.addClass('loaded');
                    }
                    if ($codeMirrorToggler.length) {
                        $codeMirrorToggler.trigger('change');
                    }
                },
            });
        });
    }
}
